import API from '@/assets/api.svg';
import Rich from '@/assets/rich.svg';
import Mark from '@/assets/markdown.svg';

export const DocNav = [
  { name: '管理员' },
  { name: '开发文档管理', active: true },
];
export const DOCOperation = [
  {
    name: 'doc_item_offline',
    key: 'offline',
  },
  {
    name: 'doc_item_online',
    key: 'online',
  },
  {
    name: 'doc_same_create',
    key: 'same',
    children: [
      {
        name: 'api_doc',
        key: 'api',
        img: API,
      },
      {
        name: 'rich_doc',
        key: 'rich',
        img: Rich,
      },
      {
        name: 'mk_doc',
        key: 'markdown',
        img: Mark,
      },
    ],
  },
  {
    name: 'doc_subset_create',
    key: 'sub',
    children: [
      {
        name: 'api_doc',
        key: 'sub_api',
        img: API,
      },
      {
        name: 'rich_doc',
        key: 'sub_rich',
        img: Rich,
      },
      {
        name: 'mk_doc',
        key: 'sub_markdown',
        img: Mark,
      },
    ],
  },
  {
    name: 'delete',
    key: 'delete',
  },
];
export const IconMap: any = {
  API: { icon: API, name: 'api_doc', title: '请选择接口' },
  RICH: { icon: Rich, name: 'rich_doc', title: '请编辑标题' },
  MARKDOWN: { icon: Mark, name: 'mk_doc', title: '请编辑标题' },
};
export const DocTypeList = [
  { key: 'rich_doc', value: 'RICH', title: '请编辑标题' },
  { key: 'mk_doc', value: 'MARKDOWN', title: '请编辑标题' },
  { key: 'api_doc', value: 'API', title: '请选择接口' },
];
export const LangList = [
  { value: 'CHINESE', name: '中文' },
  { value: 'ENGLISH', name: 'English' },
  { value: 'JAPANESE', name: '日本語' },
];

export const DocNavList = [{
  name: 'doc-manage', active: false, index: 1, path: '/home',
}];

export const DocLang = [
  {
    value: 'zh',
    isDefault: true,
  },
  {
    value: 'en',
    isDefault: false,
  },
  {
    value: 'ja',
    isDefault: false,
  },
];

export const LanguageMap = LangList.reduce((origin: any, next) => {
  // eslint-disable-next-line no-param-reassign
  origin[next.value] = next.name;
  return origin;
}, {});

export const DefaultDOCConfig = {
  name: '',
  description: '',
  language: 'CHINESE',
  isMultiLanguage: false,
  viewType: 'SINGLE',
  languageList: ['CHINESE'],
  config: {} as any,
};

/* eslint-disable @typescript-eslint/camelcase */
export const Tooltips = {
  header1: '一级标题 (# + 空格)',
  header2: '二级标题 (## + 空格) ',
  header3: '三级标题 (### + 空格)',
  bold: '加粗 (**{内容}**)',
  italic: '斜体 (*(内容)*)',
  underline: '下划线 (~{内容}~)',
  code_block: '代码块 (```+ 空格）',
  block_quote: '引用 (> + 空格)',
  bullet_list: '无序列表 (- + 空格)',
  ordered_list: '有序列表 （数字 + . + 空格)',
  background: '背景颜色',
  diyBackground: '背景颜色',
  color: '字体颜色',
  diyColor: '字体颜色',
  hr: '分割线 (*** + 空格)',
  strike: '删除线 (~~{内容}~~)',
  sup: '上标文本',
  sub: '下标文本',
  link: '链接 ([title](url))',
  diyLink: '链接 ([title](url))',
  image: '上传图片',
  video: '上传视频',
  undo: '撤销',
  redo: '重做',
  align_left: '左对齐',
  align_center: '居中对齐',
  align_right: '右对齐',
};

export const Toolicons = {
  header1: 'iconfont icon-h1 toolicon',
  header2: 'iconfont icon-h2 toolicon',
  header3: 'iconfont icon-h3 toolicon',
  bold: 'iconfont icon-text-bold toolicon',
  italic: 'iconfont icon-text-italic toolicon',
  underline: 'iconfont icon-text-underline toolicon',
  code_block: 'iconfont icon-code toolicon',
  block_quote: 'iconfont icon-quote toolicon',
  bullet_list: 'iconfont icon-unordered-list toolicon',
  ordered_list: 'iconfont icon-ordered-list toolicon',
  // background: '背景颜色',
  // diyBackground: 'iconfont icon-background-color toolicon',
  // color: '字体颜色',
  // diyColor: 'iconfont icon-font-color toolicon',
  hr: 'iconfont icon-dividing-line toolicon',
  strike: 'iconfont icon-strikethrough toolicon',
  // sup: '上标文本',
  // sub: '下标文本',
  table: 'iconfont icon-table toolicon',
  // link: '链接 ([title](url))',
  diyLink: 'iconfont icon-link toolicon',
  image: 'iconfont icon-pic toolicon',
  video: 'iconfont icon-Frame toolicon',
  // undo: '撤销',
  // redo: '重做',
  // align_left: '左对齐',
  // align_center: '居中对齐',
  // align_right: '右对齐',
};
